<template>
  <b-modal class="test-modal" v-model="show" hide-footer hide-header centered style="height: 100%; width: 100%"
           no-close-on-backdrop no-close-on-esc>
    <b-row style="height: 100%">
      <b-col md="8" id="viewer" style="height: 100%; padding-left: 0px; padding-right: 0px">
        <iframe :src="currentPdf" name="print_frame" id="print_frame" style="width: 100%; height: 100%; border: none; border-top-left-radius: 4px; border-bottom-left-radius: 4px"></iframe>
      </b-col>
      <b-col  style="height: 100%; padding-left: 0px">
        <h3 class="text-center" style="margin-top: 12px; margin-bottom: 12px"><b>Auswertung</b></h3>
        <b-table style="border-top-right-radius: 4px;
    margin-bottom: 0px; height: calc(100% - 150px); max-height: calc(100% - 150px);" striped hover selectable :items="data" :fields="dataFields"
                 select-mode="range"
                 selectedVariant="primary"
                 @row-selected="rowSelected"
                 ref="task_table"
                 sticky-header
        >
          <template v-slot:cell(icon)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <check-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:green" v-if="row.item.finished"></check-icon>
          </template>
        </b-table>
        <b-form-group
            style="margin-left: 12px; margin-right: 12px; margin-bottom: 0px"
        >
          <b-row class="mt-3">
            <b-col >
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" :disabled="disabled" @click="modality = 'print'; generate()">
                <print-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></print-icon>Drucken
              </b-button>
            </b-col>
            <b-col >
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" :disabled="disabled" @click="modality = 'save'; generate()">
                <download-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></download-icon>Speichern
              </b-button>
            </b-col>
            <b-col >
              <b-button variant="primary" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" @click="$emit('close'); show = false">
                <check-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></check-icon>Fertig
              </b-button>
            </b-col>
          </b-row>

        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>


import {Server_URL} from "@/shared/utils";
import pdf from 'vue-pdf'
import EurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import DownloadIcon from 'vue-material-design-icons/Download.vue';
import SendIcon from 'vue-material-design-icons/Send.vue';
import PrintIcon from 'vue-material-design-icons/CloudPrint.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';

export default {
  name: "report_overlay",
  components: {
    pdf,
    EurIcon,
    DownloadIcon,
    SendIcon,
    PrintIcon,
    CheckIcon
  },

  data() {
    return {
      show: false,
      data: [],
      selected: [],
      currentPdf: 'Bitte Auswaehlen.pdf',
      currentNumber: 1,
      rnrPrefix: '10-2025',
      modality: 'send',
      currentIndex: -1,
      currentPreview: null,
      reportType: null,
      reportSubType: null,
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  computed: {
    dataFields() {
      return [
        {
          key: 'name', label: 'Name', formatter: (value, key, item) => {
            return item.name
          }
        },
      ]
    },
    disabled() {
      for (let i = 0; i < this.selected.length; i++) {
        if (!this.selected[i].finished) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
  },
  methods: {
    showDialog(data, reportType, reportSubType) {
      console.log("here")
      this.reportType = reportType;
      this.reportSubType = reportSubType;
      this.firstRequest = false;
      this.selected = [];
      this.data = [JSON.parse(JSON.stringify(data))];
      this.pdfs = {};
      this.currentPdf = 'Bitte Auswaehlen.pdf';
      this.show = true;
      this.currentPreview = null;

      this.$nextTick(() => {
        this.$refs.task_table.selectRow(0);
      });

    },
    rowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.currentPdf = 'Bitte Auswaehlen.pdf';
        return;
      }
      this.showPreview();
    },
    showPreview() {
      let item = this.selected[0];
      if (item.name === this.currentPreview) {
        return
      }
      console.log(item)
      this.currentPreview = item.name;
      this.showLoader();
      let fileName = item.filename;
      this.$http.post(
          Server_URL+'/auftragsbuch/report/preview/'+this.reportType + "?reportSubType=" + this.reportSubType + "&fileName=" + fileName,
          item
      ).then((response) => {
        this.hideLoader();
        this.firstRequest = true;
        if (response.status === 200 ) {
          const byteCharacters = atob(response.body);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const b = new Blob([byteArray], {type: "application/pdf"});
          b.name = "test.pdf";
          this.currentPdf = URL.createObjectURL(b);
        } else {
          console.log(response);
        }
      }, (response) => {
        this.firstRequest = true;
        this.hideLoader();
        console.log(response);
      });
    },
    generate() {
      this.currentIndex = -1;
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].finished === false) {
          this.currentIndex = i;
          break;
        }
      }
      if (this.currentIndex === -1) {
        this.hideLoader();
        return;
      }
      this.showLoader();
      let item = this.selected[this.currentIndex];
      let req = {};
      let isEinzel = false;

      console.log(req)
      this.currentNumber +=1;
      this.$http.post(
          Server_URL+'/auftragsbuch/report/generate/'+this.reportType + "?reportSubType=" + this.reportSubType,
          item
      ).then((response) => {
        this.firstRequest = true;
        if (response.status === 200 ) {
          this.selected[this.currentIndex].finished = true;
          this.selected[this.currentIndex].filename = response.body.file_name;
          const byteCharacters = atob(response.body.fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const b = new Blob([byteArray], {type: "application/pdf"});
          b.name = "Auswertung.pdf";
          this.currentPdf = URL.createObjectURL(b);
          setTimeout(() => {
            window.frames["print_frame"].focus();
            if (this.modality === 'print') {
              window.frames["print_frame"].print();
              // wait till print dialog is closed
              const cleanup = () => {
                window.frames["print_frame"].removeEventListener('focus', cleanup);
                this.generate();
              };
              // Add an event listener to detect when the window gains focus again
              window.frames["print_frame"].addEventListener('focus', cleanup);
            } else if (this.modality === 'save') {
              const a = document.createElement('a');
              a.href = this.currentPdf;
              a.download =  "Auswertung.pdf";
              a.style.position = 'fixed';
              a.target = '_blank';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setTimeout(() => {
                this.generate();
              }, 400)
            } else {
              setTimeout(() => {
                this.generate();
              }, 400)
            }
          },500);
        } else {
          this.hideLoader();
          console.log(response);
        }
      }, (response) => {
        this.firstRequest = true;
        this.hideLoader();
        console.log(response);
      });
    }
  },
}
</script>

<style scoped>

::v-deep .modal-dialog {
  max-width: 100%;
  margin: 20px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100vh - 40px);
  display: flex;
  position: fixed;
  z-index: 100000;
}

::v-deep .modal-content {
  height: calc(100vh - 40px);
  border: none;
  border-radius: 4px;
}

::v-deep .modal-body {
  height: 100%;
  padding: 0;
}

.form-control {
  color: black;
}

</style>
